import { BasePage } from '@/components/ui/base-page'

export function FranchisePage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add FranchisePage specific content here */}
    </BasePage>
  )
}